import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AnwenderbetriebService } from '@service/anwenderbetrieb.service';
import { Anwenderbetrieb } from '@entity/anwenderbetrieb';

export const AnwenderbetriebResolve: ResolveFn<Anwenderbetrieb> = (route) => {
  return inject(AnwenderbetriebService).getAnwenderbetrieb(route.params.id);
};
